module.exports = __webpack_public_path__ + "static/img/404.2ea66c0.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/error/404.gif
// module id = vUjX
// module chunks = 5